import { OpenAPIV3 } from "../@types";
import { Avatar, AvatarPictureType } from "../model";

/** Provides generic HTML (Bootstrap 3 in this version) for rendering Grid cells. */
export class CellRenderingLogic {

  /**
   * Gets an agGrid cell renderer based on the property schema.
   * @param schemaProp The schema of the property that is being rendered
   * @returns A cell renderer for AGGrid. Currently always a function: May later be a component.
   * Null, if the column should be rendered using default functionality.
   */
  public static getCellRenderer(schemaProp: OpenAPIV3.NonArraySchemaObject): ((item: any) => string) | undefined {
    switch (schemaProp.format) {
      case "Employment":

        return (item) => `<div>${this.getAvatar(item?.value?.personalInfo.avatar)} ${ item?.value?.personalInfo.avatar.sortableName || "-" }</div>`;
      case "Avatar":
        return (item) => `<div>${this.getAvatar(item?.value)} ${ item?.value?.sortableName || "-" }</div>`;
    }
    return undefined;
  }

  /**
   * Renders an avatar as a picture / icon
   * @param avatar The avatar objec that should be rendered.
   * @param fontSize Optional font size. Default is 2em, which typically good in agGrid.
   * @returns HTML for the avatar.
   */
  public static getAvatar(avatar: Avatar, fontSize = "2em"): string {
    const isImage = avatar
      && (avatar.pictureType === AvatarPictureType.Uploaded || avatar.pictureType === AvatarPictureType.Gravatar)
      && avatar.url?.substring(0, 4).toLowerCase() === "http";
    const isPersonIcon = avatar != null && !isImage && avatar.entityType !== "company";
    const initials = avatar ? (avatar.initials || "-") : "?";
    const color = this.getColor(avatar.color as string);

    if (isImage) {
      return `<span class="salaxy-avatar" style="width: 1em; height: 1em; font-size: ${fontSize}"><img src="${avatar.url}" /></span>`;
    }
    return `<span class="salaxy-avatar" style="width: 2.5em; height: 2.5em;">
      <i class="salaxy-avatar bi ${ isPersonIcon ? "bi-person-fill" : "bi-square-fill" }" style="color: ${ color || "gray"}; font-size: ${fontSize}">
        <strong style="text-shadow: 1px 1px 0px ${ color || "gray"}, -1px -1px 0px ${ color || "gray"}, 1px -1px 0px ${ color || "gray"}, -1px 1px 0px ${ color || "gray"}">${initials}</strong>
      </i>
    </span>`;
  }

    /**
     * Return the color for the avatar icon and line strokes. NOTE: identical method as in AvatarController.ts. Will be refactored at a later date.
     * If some colors require adjustments due to accessibility reasons, they can be implemented here.
     */
    private static getColor(color: string): string {
      switch (color) {
        case "yellow":
          return "#ebc000";
        case "lime":
          return "limegreen";
        case "pink":
          return "#ff8fa2";
        default:
          return color;
      }
    }
}